import { instance } from '@/services/avik-api-gateway'
import { DeviationCancel } from '@/types/deviation-cancel'
import { AxiosResponse } from 'axios'

export function deleteDeviationCancel(
  deviationCancelUuid: string
): Promise<AxiosResponse<DeviationCancel>> {
  return instance.delete(`/deviation-cancel/${deviationCancelUuid}`)
}
